/* eslint-disable */
import { useCallback, useState, useMemo, useEffect, Fragment, SetStateAction, Dispatch } from 'react'
import styled from 'styled-components'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { Text, Flex, Box, Skeleton, ArrowBackIcon, ArrowForwardIcon, Input } from '@noahswap/uikit'
import { formatAmount, formatPrice, formatUsd, formatNumber } from 'utils/formatInfoNumbers'
import { PoolData } from 'state/info/types'
import { ITEMS_PER_INFO_TABLE_PAGE } from 'config/constants/info'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { useTranslation } from '@noahswap/localization'
import { ClickableColumnHeader, TableWrapper, PageButtons, Arrow, Break } from './shared'

/**
 *  Columns on different layouts
 *  5 = | # | Pool | TVL | Volume 24H | Volume 7D |
 *  4 = | # | Pool |     | Volume 24H | Volume 7D |
 *  3 = | # | Pool |     | Volume 24H |           |
 *  2 = |   | Pool |     | Volume 24H |           |
 */
const ResponsiveGrid = styled.div<{ tableHead?: boolean }>`
  display: grid;
  grid-gap: 1em;
  align-items: center;
  grid-template-columns: 230px repeat(4, 2fr);
  /* grid-template-columns: repeat(4, 2fr); */
  background: ${({ tableHead }) => (tableHead ? '#FaFaFa' : '#fff')};

  padding: ${({ tableHead }) => (tableHead ? '8px 24px' : '0 24px')};
  margin-top: ${({ tableHead }) => (tableHead ? '10px' : '0px')};
  border-radius: ${({ tableHead }) => (tableHead ? '8px' : '0px')};
  text-align: center;
  /* padding: 0 24px; */
  /* @media screen and (max-width: 900px) {
    grid-template-columns: 200px 1.5fr repeat(3, 2fr);
    & :nth-child(4) {
      display: none;
    }
  } */
  @media screen and (max-width: 500px) {
    grid-template-columns: 20px 1.5fr repeat(1, 1fr);
    & :nth-child(2),
    & :nth-child(3) {
      display: none;
    }
  }
  @media screen and (max-width: 480px) {
    grid-template-columns: 2.5fr repeat(1, 1fr);
    > *:nth-child(1) {
      display: none;
    }
  }
`

const LinkWrapper = styled(NextLinkFromReactRouter)`
  text-decoration: none;
  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

const StyledInput = styled(Input)<{ inputBlur?: boolean }>`
  width: 200px;
  z-index: 9999;
  border: 1px solid;
  /* border-color: #e9e9e9; */
  font-size: 14px;
  color: #000;
  padding-left: 36px;
  border-radius: 5px;
  height: 28px;
  border-color: ${({ inputBlur }) => (inputBlur ? '#000' : '#e9e9e9')};
`

const SearchDeleteIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 45%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  color: #000;
`

const SearchLogo = styled.img`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`

const FlexRow = styled.div<{ active: boolean }>`
  cursor: pointer;
  background: ${({ active }) => (active ? '#FAD436' : '#fff')};
  border-width: 1px;
  border-style: solid;
  font-size: 14px;
  /* font-weight: ${({ active }) => (active ? 600 : 400)}; */
  padding: 5px 10px;
  border-radius: 6px;
  border-color: ${({ active }) => (active ? '#14162A' : '#fff')};
  margin-right: 10px;
`

const SORT_FIELD = {
  liquidityUSD: 'liquidityUSD',
  volumeUSD: 'volumeUSD',
  // volumeUSDWeek: 'volumeUSDWeek',
  // lpFees24h: 'lpFees24h',
  // lpApr7d: 'lpApr7d',
  price: 'price',
  priceChange: 'priceChange',
}

const LoadingRow: React.FC<React.PropsWithChildren> = () => (
  <ResponsiveGrid>
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </ResponsiveGrid>
)

const TableLoader: React.FC<React.PropsWithChildren> = () => (
  <>
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
  </>
)

const DataRow = ({ poolData, index }: { poolData: PoolData; index: number }) => {
  let symbolChange = {
    token0: poolData?.token0,
    token1: poolData?.token1,
  }
  // const symbolArr = ['DAI', 'USDT', 'USDC']
  // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
  //   symbolChange = {
  //     token0: poolData?.token1,
  //     token1: poolData?.token0,
  //   }
  // }

  if (poolData?.direction === 1) {
    symbolChange = {
      token0: poolData?.token1,
      token1: poolData?.token0,
    }
  }

  const priceChange =
    poolData.priceChange > 0
      ? `+${poolData.priceChange.toFixed(2)}`
      : poolData.priceChange === 0
      ? '0.00'
      : `${poolData.priceChange.toFixed(2)}`
  return (
    <LinkWrapper to={`/info/pools/${poolData.address}`}>
      <ResponsiveGrid>
        <Flex alignItems="center">
          <DoubleCurrencyLogo token0={symbolChange.token0} token1={symbolChange.token1} size={30} />
          <Flex style={{ marginLeft: '30px' }}>
            <Text style={{ fontWeight: 500 }}>{symbolChange?.token0?.symbol}</Text>
            <Text style={{ fontWeight: 500 }} color="#92929B">
              /{symbolChange?.token1?.symbol}
            </Text>
          </Flex>
          {/* {poolData.address === '0x2dfada2212e534b7e234fb877dca4ddcaef049b7' && ( */}
          {poolData.newPair && (
            <Flex style={{ marginLeft: '10px' }}>
              <img src="/images/ad/new.png" alt="" width="36" />
            </Flex>
          )}
        </Flex>
        <Flex
          alignItems="flex-end"
          justifyContent="flex-end"
          flexDirection="column"
          style={{ flexFlow: !poolData?.priceUsd && 'wrap' }}
        >
          <Text>{formatNumber(formatPrice(poolData.price), poolData.price)}</Text>
          {poolData?.priceUsd ? (
            <Text fontSize="12px" color="#92929B">
              ${formatNumber(formatUsd(poolData.priceUsd), poolData.priceUsd)}
            </Text>
          ) : (
            <Text fontSize="12px" color="#92929B">
              &nbsp;
            </Text>
          )}
        </Flex>
        <Text color={poolData.priceChange > 0 ? 'green' : poolData.priceChange < 0 ? 'red' : ''} textAlign="right">
          {priceChange}%
        </Text>
        <Text textAlign="right">${formatAmount(poolData.volumeUSD)}</Text>
        <Text textAlign="right">${formatAmount(poolData.liquidityUSD)}</Text>
      </ResponsiveGrid>
    </LinkWrapper>
  )
}

interface QuotationTableProps {
  poolDatas: PoolData[]
  loading?: boolean // If true shows indication that SOME pools are loading, but the ones already fetched will be shown
  title?: string
  searchValue?: string
  setSearchValue?: Dispatch<SetStateAction<string>>
  tableType?: number
  setTableType?: Dispatch<SetStateAction<number>>
}

const QuotationTable: React.FC<React.PropsWithChildren<QuotationTableProps>> = ({
  poolDatas,
  loading,
  title,
  searchValue,
  setSearchValue,
  tableType,
  setTableType,
}) => {
  // for sorting
  const [sortField, setSortField] = useState(SORT_FIELD.liquidityUSD)
  const [sortDirection, setSortDirection] = useState<boolean>(true)
  const { t } = useTranslation()

  // pagination
  const [page, setPage] = useState(1)
  const [maxPage, setMaxPage] = useState(1)
  const [inputBlur, setInputBlur] = useState(false)
  // useEffect(() => {
  //   let extraPages = 1
  //   if (poolDatas?.length % ITEMS_PER_INFO_TABLE_PAGE === 0) {
  //     extraPages = 0
  //   }
  //   setMaxPage(Math.floor(poolDatas?.length / ITEMS_PER_INFO_TABLE_PAGE) + extraPages)
  // }, [poolDatas])

  const sortedPools = useMemo(() => {
    return poolDatas
      ? poolDatas.sort((a, b) => {
          if (a && b) {
            return a[sortField as keyof PoolData] > b[sortField as keyof PoolData]
              ? (sortDirection ? -1 : 1) * 1
              : (sortDirection ? -1 : 1) * -1
          }
          return -1
        })
      : // .slice(ITEMS_PER_INFO_TABLE_PAGE * (page - 1), page * ITEMS_PER_INFO_TABLE_PAGE)
        []
  }, [page, poolDatas, sortDirection, sortField])

  const handleSort = useCallback(
    (newField: string) => {
      setSortField(newField)
      setSortDirection(sortField !== newField ? true : !sortDirection)
    },
    [sortDirection, sortField],
  )

  const arrow = useCallback(
    (field: string) => {
      const directionArrow = !sortDirection ? '↑' : '↓'
      return sortField === field ? directionArrow : ''
    },
    [sortDirection, sortField],
  )

  const handleSearchValue = (e) => {
    setSearchValue(e.target.value)
  }
  const handleTab = (id) => {
    setTableType(id)
  }
  const tabArr = [
    {
      id: 0,
      label: t('noah92'),
    },
    {
      id: 1,
      label: 'EOS',
    },
    {
      id: 2,
      label: t('noah196'),
    },
  ]
  return (
    <TableWrapper style={{ padding: loading ? '24px' : '24px', minHeight: '80vh' }}>
      <Flex>
        <Text color="#000" fontSize="20px" bold>
          {title}
        </Text>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center">
        {!searchValue ? (
          <Flex>
            {tabArr.map((v) => {
              return (
                <FlexRow key={v.id} active={v.id === tableType} onClick={() => handleTab(v.id)}>
                  {v.label}
                </FlexRow>
              )
            })}
          </Flex>
        ) : (
          <Flex>
            <Text fontSize="14px" color="#92929B">
              {t('%num% results found', { num: poolDatas?.length })}
            </Text>
          </Flex>
        )}
        <div style={{ position: 'relative' }}>
          <SearchLogo src="/images/small-img/icon3.png" width={16} alt="" />
          <div style={{ position: 'relative' }}>
            <StyledInput
              type="text"
              onFocus={() => setInputBlur(true)}
              onBlur={() => setInputBlur(false)}
              inputBlur={inputBlur}
              value={searchValue}
              onChange={handleSearchValue}
              placeholder={t('noah100')}
            />
            {searchValue && <SearchDeleteIcon onClick={() => setSearchValue('')}>×</SearchDeleteIcon>}
          </div>
        </div>
      </Flex>
      <ResponsiveGrid tableHead>
        {/* 流动池 */}
        <Text color="#000" fontSize="12px" bold textAlign="left">
          {t('noah37')}
        </Text>
        <ClickableColumnHeader
          color="#000"
          fontSize="12px"
          bold
          onClick={() => handleSort(SORT_FIELD.price)}
          textAlign="right"
        >
          {/* 价格 */}
          {t('noah81')}
          {arrow(SORT_FIELD.price)}
        </ClickableColumnHeader>
        <ClickableColumnHeader
          color="#000"
          fontSize="12px"
          bold
          onClick={() => handleSort(SORT_FIELD.priceChange)}
          textAlign="right"
        >
          {/* 价格变化 */}
          {t('noah91')}
          {arrow(SORT_FIELD.priceChange)}
        </ClickableColumnHeader>
        <ClickableColumnHeader
          color="#000"
          fontSize="12px"
          bold
          onClick={() => handleSort(SORT_FIELD.volumeUSD)}
          textAlign="right"
        >
          {t('noah194')} {arrow(SORT_FIELD.volumeUSD)}
        </ClickableColumnHeader>
        <ClickableColumnHeader
          color="#000"
          fontSize="12px"
          bold
          onClick={() => handleSort(SORT_FIELD.liquidityUSD)}
          textAlign="right"
        >
          {t('noah37')} {arrow(SORT_FIELD.liquidityUSD)}
        </ClickableColumnHeader>
      </ResponsiveGrid>
      {/* <Break /> */}
      {loading ? (
        <TableLoader />
      ) : sortedPools.length > 0 ? (
        <>
          {sortedPools.map((poolData, i) => {
            if (poolData) {
              return (
                <Fragment key={poolData.address}>
                  <DataRow index={(page - 1) * ITEMS_PER_INFO_TABLE_PAGE + i} poolData={poolData} />
                  {i < sortedPools.length - 1 && <Break />}
                </Fragment>
              )
            }
            return null
          })}
          {/* loading状态 */}
          {/* {loading && <LoadingRow />} */}
          {/* <PageButtons>
            <Arrow
              onClick={() => {
                setPage(page === 1 ? page : page - 1)
              }}
            >s
              <ArrowBackIcon color={page === 1 ? 'textDisabled' : 'primary'} />
            </Arrow>

            <Text>{t('Page %page% of %maxPage%', { page, maxPage })}</Text>

            <Arrow
              onClick={() => {
                setPage(page === maxPage ? page : page + 1)
              }}
            >
              <ArrowForwardIcon color={page === maxPage ? 'textDisabled' : 'primary'} />
            </Arrow>
          </PageButtons> */}
        </>
      ) : (
        <Flex flexDirection="column" alignItems="center" justifyContent="center" height="500px">
          <img src="/images/small-img/noData.png" width={100} alt="" />
          <Text textAlign="center" maxWidth="400px" fontSize="16px" mt="16px" color="#85868A">
            {t('noah116')}
          </Text>
        </Flex>
      )}
    </TableWrapper>
  )
}

export default QuotationTable
